<template>
    <div class="flex w-full justify-between">
        <user-list-item :user="user" />
        <div v-if="user.role === 'ADMIN'" class="text-white text-xxs my-auto min-w-fit">
            GROUP ADMIN
        </div>
    </div>
</template>
<script setup lang="ts">

import {PropType} from "vue";
import UserVerificationCheck from "@/components/UserBadges.vue";
import {ChatParticipantInterface} from "@/interfaces/ChatParticipantInterface";
import UserListItem from "@/components/UserListItem.vue";


const props = defineProps({
    user: {
        type: Object as PropType<ChatParticipantInterface>,
        required: true
    }
})

</script>
